import WFSEditorMixin from './WFSEditorMixin'
import store from '../store'

import Snap from 'ol/interaction/Snap'
import Draw from 'ol/interaction/Draw'
import {createBox} from 'ol/interaction/Draw';
import Select from 'ol/interaction/Select'
import Modify from 'ol/interaction/Modify'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import RegularShape from 'ol/style/RegularShape'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'
import Point from 'ol/geom/Point'
import Feature from 'ol/Feature'
import Collection from 'ol/Collection'
import {shiftKeyOnly} from 'ol/events/condition'
import GeoJSON from 'ol/format/GeoJSON'
import Wkt from 'ol/format/WKT'
import MultiPopup from '../components/map/designotron/MultiPopup'
import Overlay from 'ol/Overlay'
import Vue from 'vue'

import lineSplit from '@turf/line-split'
import lineIntersects from '@turf/line-intersect'
import * as olProj from 'ol/proj'
import uuidV1 from 'uuid/v1'
import waterfall from 'async/waterfall'

export default {
  mixins: [WFSEditorMixin],
  created () {
    this.drawInteraction = null
    this.splitInteraction = null
    this.snapInteraction = null
    this.selectInteraction = null
    this.modifyInteraction = null
    this.wellLayer = null
    this.wellFeature = null
    this.packageFeatures = []
    this.drawingFeature = null
    this.splittingFeature = null
    this.newFeatures = []
    this.modifiedFeatures = []
    this.removedFeatures = []
    this.m = {}
    this.servicingLayer = null
    this.historyStack = []
    this.geoJson = new GeoJSON({
      geometryName: 'geo'
    })
    this.wkt = new Wkt()
    this.multiOverlay = null
  },
  watch: {
    dEnabled (val) {
      if (!val) {
        this.destroy()
      }
    },
    ldEnabled (val) {
      if (val) {
        this.checkDep()
      } else {
        this.hideDep()
      }
    },
    showForm (val) {
      if (!val) {
        this.editEnabled = false

        // Need to clear on closing edit form, allow user to see changes & set lock state after save
        //need to clear, in order new feature not getting previous values
        for (let k in this.wellAttrs) {
          if (this.wellAttrs.hasOwnProperty(k)) {
            this.wellAttrs[k] = null
          }
        }

      } else {
        let state = store.getters['user/settings'].filter(s => s.usedfor === 'ui' && s.param === 'phase_editable_state')[0]
        let phaseId = this.wellFeature.get('phase')

        if (phaseId) {
          let options = store.getters['map/phaseOptions']
          let option = options.find(o => o.id === phaseId)
          let e = this.$store.getters['user/settings'].filter(s => s.usedfor === 'ui' && s.param === 'phase_editable_state')[0]['value']

          this.editablePhase = option.state.includes(e)
          this.featureLock = this.editablePhase ? this.wellFeature.get('locked') : true
        } else {
          this.editablePhase = true
          this.featureLock = this.wellFeature.get('locked')
        }
      }
    },
    currentEditor (val) {
      if (val !== this.editorIdent) {
        this.addEnabled = false
        this.selectEnabled = false
      }
    },
    addEnabled (val) {
      if (this.clickBound) {
        this.unBindCreateClick()
      }
      if (val && !this.validateLayer()) {
        this.addEnabled = false
        return
      }
      if (val) {
        this.selectEnabled = false
        this.splitEnabled = false
        this.currentEditor = this.editorIdent
      }

      if (val) {
        if (this.drawInteraction) {
          this.$mapService.removeInteraction(this.drawInteraction)
          this.$mapService.map.removeInteraction(this.snapInteraction)
        }

        if (this.addViaService) {
          this.bindCreateClick()

        } else {
          if (this.boxCreate) {
            this.drawInteraction = new Draw({
              source: this.wellLayer.getSource(),
              type: this.geomType,
              geometryName: this.geometryName,
              geometryFunction: createBox()
            })
          } else {
            this.drawInteraction = new Draw({
              source: this.wellLayer.getSource(),
              type: this.geomType,
              geometryName: this.geometryName,
              freehandCondition: shiftKeyOnly
            })
          }
          this.drawInteraction.on('drawend', this.addFeature, this)
          this.$mapService.addInteraction(this.drawInteraction)
          this.initSnapIteraction(this.wellLayer.getSource())
        }


      } else {
        this.$mapService.removeInteraction(this.drawInteraction)
        this.$mapService.map.removeInteraction(this.snapInteraction)
      }
    },
    splitEnabled (val) {
      if (val && !this.validateLayer()) {
        this.splitEnabled = false
        this.addEnabled = false
        this.selectEnabled = false
        return
      }
      if (val) {
        this.mapToolRightMeasureShown = false
        this.addEnabled = false
        this.selectEnabled = false
        this.mapToolRightShown = false
        this.currentEditor = this.editorIdent
      }

      if (val) {
        if (this.splitInteraction) {
          this.$mapService.removeInteraction(this.splitInteraction)
        }
        this.splitInteraction = new Draw({
          source: this.servicingLayer.getSource(),
          type: 'LineString',
          geometryName: this.geometryName,
          freehandCondition: shiftKeyOnly
        })
        this.splitInteraction.on('drawend', this.splitFeature, this)
        this.$mapService.addInteraction(this.splitInteraction)
      } else {
        this.$mapService.removeInteraction(this.splitInteraction)
      }
    },
    selectEnabled (val) {
      if (val && !this.validateLayer()) {
        this.selectEnabled = false
        return
      }
      if (val) {
        this.mapToolRightMeasureShown = false
        this.mapToolRightShown = false
        this.addEnabled = false
        this.splitEnabled = false
        this.currentEditor = this.editorIdent
      } else {
        this.dragEnabled = false
        this.editEnabled = false
        this.rotateEnabled = false
        this.translateEnabled = false
      }

      if (val) {
        if (this.selectInteraction) {
          this.$mapService.removeInteraction(this.selectInteraction)
        }
        this.initSelectInteraction()
        this.$mapService.addInteraction(this.selectInteraction)
      } else {
        this.$mapService.removeInteraction(this.selectInteraction)
        this.wellFeatureSelected = false
        this.servicingLayer.getSource().clear()
      }

    },
    dragEnabled (val) {
      if (val) {
        this.editEnabled = false
        this.rotateEnabled = false
      }

      let selF = e => {
        e.selected.forEach(f => f.on('change', this.selectedFeatures2Nodes, this))
      }
      let deselF = e => {
        e.deselected.forEach(f => f.un('change', this.selectedFeatures2Nodes, this))
      }
      if (val) {
        if (this.modifyInteraction) {
          this.$mapService.removeInteraction(this.modifyInteraction)
          this.$mapService.map.removeInteraction(this.snapInteraction)
          this.modifyInteraction = null
        }
        this.modifyInteraction = new Modify({
          features: this.selectInteraction.getFeatures()
        })
        this.modifyInteraction.on('modifyend', this.editGeom, this)
        this.modifyInteraction.on('modifystart', this.beforeEditGeom, this)

        this.$mapService.addInteraction(this.modifyInteraction)
        this.initSnapIteraction(this.wellLayer.getSource())
        this.selectInteraction.on('select', this.selectedFeatures2Nodes, this)
        this.selectInteraction.getFeatures().forEach(f => f.on('change', this.selectedFeatures2Nodes, this))
        this.selectedFeatures2Nodes()
        this.selectInteraction.on('select', selF)
        this.selectInteraction.on('deselect', deselF)
      } else {
        this.$mapService.removeInteraction(this.modifyInteraction)
        this.$mapService.map.removeInteraction(this.snapInteraction)
        this.selectInteraction.un('select', this.selectedFeatures2Nodes, this)
        this.selectInteraction.getFeatures().forEach(f => f.un('change', this.selectedFeatures2Nodes, this))
        this.selectInteraction.un('select', selF)
        this.selectInteraction.un('deselect', deselF)
      }

    },
    editEnabled (val) {
      if (val) {
        this.dragEnabled = false
      }

      if (val) {
        this.editProps(this.selectInteraction.getFeatures().getArray()[0])
      }
    },
    mapToolRightMeasureShown (val) {
      if (val) {
        this.addEnabled = false
        this.selectEnabled = false
      }
    },
    mapToolRightShown (val) {
      if (val) {
        this.addEnabled = false
        this.selectEnabled = false
      }
    }
  },
  computed: {
    user: () => store.getters['user/user'],
    dEnabled: () => store.getters['map/designotron']['enabled'],
    /*otfCommentShow: {
      get () {
        return store.state.map.otfCommentShow
      },
      set (val) {

        store.commit('setOtfCommentShow', val)
      }
    },*/
    qeuedLayers: {
      get () {
        return store.getters['map/qeuedLayers']
      },
      set (val) {
        store.commit('map/qeuedLayers', val)
      }
    },
    currentEditor: {
      get () {
        return store.getters['map/currentEditor']
      },
      set (val) {
        store.commit('map/currentEditor', val)
      }
    },
    currentProject () {
      return store.getters['project/currentProject']
    },
    showSearch: {
      get() {
        return store.getters['map/searchShow']
      },
      set(val) {
        store.commit('map/searchShow', val)
      },
    },
    showProjectList: {
      get() {
        return store.getters['project/showProjectList']
      },
      set(val) {
        store.commit('project/showProjectList', val)
      },
    },
    menuRightCls: {
      get() {
        return store.getters['user/menuRightCls']
      },
      set(val) {
        store.commit('user/menuRightCls', val)
      }
    }
  },
  props: {
    editorIdent: {
      default: 'well'
    },
    editorName: {
      default: 'Well'
    },
  },
  mounted () {
    /*if (this.editorIdent === 'well') {
      this.otfCommentShow = true
    }*/

    // this.loadLiveLayers()
    this.checkResources()
    this.initServicingLayer()
    // this.ldEnabled = true

    // Client doesnt want below

    // if (this.editorIdent === 'centreline') {
    //   // Turning on centreline direction on mount is enough
    //   this.dirLayer = this.getLayersByName('v4:_centreline_direction')[0]
    //   this.dirLayer && this.$mapService.forceCreateLayer(this.dirLayer);
    //   if (!this.dirLayer) {
    //     this.$notify({
    //       title: 'ERROR',
    //       text: 'No centreline direction layer found',
    //       type: 'warning'
    //     })
    //   }
    // }
  },
  destroyed () {
    this.destroy()
  },
  data () {
    return {
      wellLayerLoaded: false,
      wellFeatureSelected: false,
      countSelectedFeatures: 0,
      addEnabled: false,
      splitEnabled: false,
      selectEnabled: false,
      dragEnabled: false,
      editEnabled: false,
      rotateEnabled: false,
      translateEnabled: false,
      ldEnabled: false,
      wellAttrs: {},
      showForm: false,
      formTitle: null,
      historyChanges: false,
      saving: false,
      wellLayerName: 'v4:well',
      geomType: 'Point',
      geometryName: 'geo',
      idName: 'id',
      dependantLayers: [],
      liveLayer: false,
      markLastModified: true,
      featureLock: false,
      editablePhase: true,
      clickBound: false
    }
  },
  methods: {
    mergeLines() {
      let lines = this.selectInteraction.getFeatures().getArray()
      let line1 = this.wkt.writeGeometry(lines[0].getGeometry())
      let line2 = this.wkt.writeGeometry(lines[1].getGeometry())
      let ident = uuidV1()

      this.$http.post('/api/layers/merge-lines/', {
        'line1': line1,
        'line2': line2
      }).then(res => {
        let wktLine = res.body.line
        if (wktLine.toLowerCase().indexOf('multi') > -1) {
          this.$notify({
            title: 'ERROR',
            text: 'Could not merge lines, probably they are disjoint',
            type: 'error'
          })
          return
        }

        let geom = this.wkt.readGeometry(wktLine)
        let f = new Feature({
          'ident': ident,
          'workpack_id': this.currentProject.workpack.id
        })

        f.setGeometryName(this.geometryName)
        f.setGeometry(geom)
        f.set(this.geometryName, geom)
        f.set('last_modified_user', this.user.username)
        f.set('last_modified_date', new Date().toISOString())

        this._delete(lines)
        lines.forEach(line => {
          this.historyStack.push({
            'feature': line,
            'action': 'delete'
          })
        })

        this._addFeature(f)
        this.historyStack.push({
          'feature': f,
          'action': 'add'
        })
      }, res => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not merge lines',
          type: 'error'
        })
      })
    },
    destroy () {
      // Fix for feature selection on destroy
      if (this.clickBound) {
        this.unBindCreateClick()
      }
      this.qeuedLayers = this.dependantLayers.length
      this.hideDep()
      this.$mapService.removeInteraction(this.selectInteraction)
      this.drawInteraction && this.$mapService.removeInteraction(this.drawInteraction)
      this.snapInteraction && this.$mapService.map.removeInteraction(this.snapInteraction)
      this.wellFeatureSelected = false
      this.servicingLayer.getSource().clear()
      this.deinitServicingLayer()
    },
    bindCreateClick () {
      this.$mapService.addListener('click', this.addViaServiceEvent, this)
      this.clickBound = true
    },
    unBindCreateClick () {
      this.$mapService.removeListener('click', this.addViaServiceEvent, this)
      this.clickBound = false
    },
    addViaServiceEvent (e) {
      // TODO: switch on schema type
      waterfall([
        (clb) => {
          if (this.lockable) {
            this.$http.post('/api/layers/check-batch-lock-state/', {
              workpack_id: this.currentProject.workpack.id,
              geo: `POINT(${e.coordinate.join(' ')})`
            }).then(res => {
                if (res.body && res.body.batch_locked) {
                  clb('Batch locked, cannot save')
                } else {
                  clb(null)
                }
              }, res => {
                clb('Failed to validate if batch locked')
            })
          } else {
            clb(null)
          }
        },
        (clb) => {
          this.$http.post(`/api/layers/create-wellpad/`, {
            point: `POINT(${e.coordinate.join(' ')})`,
            workpack: this.currentProject.workpack.id
          })
            .then(res => {
              this.$notify({
                title: 'SUCCESS',
                text: 'Wellpad created',
                type: 'success'
              })
              this.saveCallback()
              clb(null)
            }, res => {
              clb('Could not create wellpad')
            })
        }
      ], (err, res) => {
        if (err) {
          this.saving = false
          this.$notify({
            title: 'ERROR',
            text: err,
            type: 'error'
          })
          this.historyChanges = this.historyStack.length > 0
          this.resetChanges()
        }

      })

    },
    initSnapIteraction (source) {
      this.snapInteraction = new Snap({
        source: source,
        edge: false,
        pixelTolerance: 15
      })

      this.$mapService.map.addInteraction(this.snapInteraction)

    },
    isToolEnabled(toolName) {
      if (!this.currentProject || !this.currentProject.workpack) {
        return false
      }
      let enabled = true
      if (this.currentProject.workpack && this.currentProject.workpack['tool_map']) {
        enabled = this.currentProject.workpack['tool_map']['*'] || this.currentProject.workpack['tool_map'][toolName]
      }
      return enabled
    },
    validateIdent (val, clb, obj) {
      let params = {
        ident: val,
        schema: this.schema,
        workpack: this.currentProject.workpack.id
      }

      params = Object.assign(params, obj || {})

      this.$http.get('/api/layers/validate-ident', {
        params: params
      }).then(res => {
          if (res.body.idents && res.body.idents.length == 0) {
            this.identState = true
            if (clb) {
              clb(val)
            }
          } else {
            this.identState = false
          }
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Failed to validate ident',
            type: 'error'
          })
        })
    },
    setLockState (val) {
      this.wellFeature.set('locked', val)
      this.featureLock = val
      this.$http.get('/api/layers/feature-toggle-lock', {
        params: {
          id: this.wellFeature.get('id'),
          locked: val,
          schema: this.schema
        }
      })
        .then(res => {
          this.$notify({
            title: 'SUCCESS',
            text: 'Lock state saved',
            type: 'success'
          })
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Lock state failed to save',
            type: 'error'
          })
        })
    },
    updateFeatureFromSurvey () {
      this.$http.get('/api/layers/update-feature-from-survey', {
        params: {
          id: this.wellFeature.get('id'),
          schema: this.schema
        }
      })
        .then(res => {
          this.$notify({
            title: 'SUCCESS',
            text: 'Feature Updated',
            type: 'success'
          })
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Feature failed to update',
            type: 'error'
          })
        })
    },
    hideDep () {
      this.loadDependantLayers(() => {
        this.getLayersByName(this.dependantLayers).forEach(layer => {
          layer.checked = false
          let q = store.getters['map/qeuedLayers']
          if (q > 0) {
            --q
            store.commit('map/qeuedLayers', q)
          }
          this.$mapService.checkVisibility({...layer})
        })
      })
    },
    checkDep () {
      if (this.qeuedLayers > 0) {
        let unwatch = this.$watch('qeuedLayers', (val) => {
          if (val === 0) {
            unwatch()
            this.checkResources()
          }
        });

      }
      this.loadDependantLayers(() => {
        this.getLayersByName(this.dependantLayers).forEach(layer => {
          // layer.checked = true
          // this.$mapService.forceCreateLayer(layer)

          let exists = this._layerExists(layer)
          if (exists) {
            exists.setVisible(layer['checked'])
          }

        })
      })
    },
    loadDependantLayers (clb) {
      this.$http.get(`/api/layers/otf-dependent/?key=${[this.editorIdent, 'dependant'].join('_')}`)
        .then(res => {
          this.dependantLayers = (res.body.layers || '').split(',').map(l => l.trim())
          clb && clb()
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not get dependant layers',
            type: 'error'
          })
        })
    },
    selectedFeatures2Nodes () {
      this.servicingLayer.getSource().clear()
      let fs = []
      this.selectInteraction.getFeatures().forEach(f => {
        f.getGeometry().getCoordinates().forEach(c => {
          let node = new Feature(new Point(c))
          fs.push(node)
        })
      })

      this.servicingLayer.getSource().addFeatures(fs)
    },
    initServicingLayer () {
      this.deinitServicingLayer()
      let style = new Style({
        image: new RegularShape({
          fill: new Fill({
            color: '#ff0066'
          }),
          stroke: new Stroke({
            color: 'black',
            width: 1
          }),
          points: 4,
          radius: 7,
          angle: Math.PI / 4
        })
      })
      this.servicingLayer = new VectorLayer({
        source: new VectorSource({
          features: []
        }),
        style: style
      })

      this.$mapService.map.addLayer(this.servicingLayer)
    },
    deinitServicingLayer () {
      if (this.servicingLayer) {
        this.addEnabled = false
        this.selectEnabled = false
        this.$mapService.map.removeLayer(this.servicingLayer)
      }
    },
    saveCallback () {
      this.getLayersByName(this.dependantLayers).forEach(layer => {
        layer.checked = true
        this.$mapService.forceCreateLayer(layer)
      })
      if (this.schema === 'centreline' && this.showForm) {
        let me = this
        let clb = function() {
          me.$notify({
            title: 'Success',
            text: 'KEGS Generated Pipes reloaded',
            type: 'success'
          })
        }

        // TODO: this needs to be improved
        this.loadDefaultPipes(clb)
      }
    },
    beforeSaveCallback () {

    },
    editProps (feature) {
      this.wellFeature = feature

      if (this.editPropsHook) {
        this.editPropsHook.call(this)
      }
      let attrs = {}
      if (this.wellFeature) {
        for (let k in this.wellAttrs) {
          if (this.wellAttrs.hasOwnProperty(k)) {
            attrs[k] = this.wellFeature.get(k)
            if (k === 'putondate' && attrs[k] && attrs[k].indexOf('Z') === (attrs[k].length - 1)) {
              attrs[k] = attrs[k].substring(0, attrs[k].length - 1)
            }
          }
        }
        this.wellAttrs = attrs
        // WORKAROUND FOR LTE SCHEMA FROM ARROW
        let identField = this.identName ? this.identName : 'ident'
        this.formTitle = `Edit ${this.editorIdent}: ${this.wellFeature.get(identField)}`
        this.showSearch = false
        this.showProjectList = false
        this.menuRightCls = ''
        this.showForm = true
      }
    },
    editGeom (e) {
      this._edit(e.features)
    },
    beforeEditGeom (e) {
      e.features.forEach(f => {
        this.historyStack.push({
          'feature': f.clone(),
          'action': 'edit'
        })
      })
    },
    _edit (features) {

      features.forEach(feature => {
        if (feature.get(this.idName)) {
          if (this.markLastModified) {
            this.setLastModified(feature)
          }
          this.m[feature.get(this.idName)] = feature
        }
      })

      // if feature lockable save callback to check if lock state updated on save
      if (this.editablePhase && this.showForm) {
        let me = this
        let clb = function() {
          if (me.wellFeature && me.wellFeature.get('locked')) {
            me.$notify({
              title: 'Warning',
              text: 'This feature has been locked',
              type: 'warning'
            })
            me.featureLock = me.wellFeature.get('locked')
          }
        }
        this.save(clb)
      } else {
        this.save()
      }

      this.propagateFeatureChange('edit', features)
    },
    liveReload () {
      let lrs = this.getLayersByName([this.wellLayerName]).filter(l => l['data_type'] === 'wfs' && l['editable'])
      lrs.forEach(layer => {
        this.$mapService.forceCreateLayer(layer)
      })
    },
    destroyMultiPopup () {
      if (this.multiOverlay) {
        this.multiOverlay.cmp.$destroy()
        this.$mapService.map.removeOverlay(this.multiOverlay.o)
      }
    },
    initSelectInteraction () {
      this.selectInteraction = new Select({
        hitTolerance: 8,
        layers: [this.wellLayer],
        multi: true
      })

      this.selectInteraction.on('select', this.featureSelected, this)
      this.selectInteraction.on('deselect', this.featureSelected, this)
    },
    featureSelected (e) {
      let fn = () => {
        this.wellFeatureSelected = !!this.selectInteraction.getFeatures().getLength()
        this.countSelectedFeatures = this.selectInteraction.getFeatures().getLength()
        if (this.toolDisable && this.countSelectedFeatures === 1) {
          this.toolDisableValue = this.selectInteraction.getFeatures().getArray()[0].get(this.toolDisable)
        }
      }


      this.destroyMultiPopup()
      if (!this.multiEdit && this.selectInteraction.getFeatures().getLength() > 1) {
        let fr = this.selectInteraction.getFeatures().getArray()
        let ffs = this.selectInteraction.getFeatures()
        let me = this
        let event = e.mapBrowserEvent
        let ComponentClass = Vue.extend(MultiPopup)
        let instance = new ComponentClass({
          propsData: {
            idents: fr.map(f => f.get(this.identName || 'ident')),
            identName: this.identName
          },
          methods: {
            emitValue (ident) {
              fr.forEach(f => {
                if (f.get(this.identName || 'ident') !== ident) {
                  ffs.remove(f)
                }
              })
              me.destroyMultiPopup()
              fn()
            }
          }
        })
        instance.$mount()

        let overlay = new Overlay({
          element: instance.$el,
          autoPan: true,
          autoPanAnimation: {
            duration: 250
          }
        })

        overlay.setPosition(event.coordinate)

        Vue.nextTick(() => {
          this.$mapService.map.addOverlay(overlay)
        })

        this.multiOverlay = {
          o: overlay,
          cmp: instance
        }

      } else {
        fn()
      }
    },
    deleteFetaures () {
      this.countSelectedFeatures = this.selectInteraction.getFeatures().getLength()
      let ff = this.selectInteraction ? this.selectInteraction.getFeatures().getArray() : []
      if (ff.length) {

        this._delete(ff)
        ff.forEach(f => {
          this.historyStack.push({
            'feature': f.clone(),
            'action': 'delete'
          })
        })
        this.selectInteraction && this.selectInteraction.getFeatures().clear()
      }
    },
    _delete (features, dry) {
      let identField = this.identName ? this.identName : 'ident'
      features.forEach(f => {
        if (f.get(this.idName)) {
          let ff = f.clone()
          ff.setId(f.get(this.idName))
          this.removedFeatures.push(ff)
        }
        let origF = this.wellLayer.getSource().getFeatures()
          .filter(fo => {
            return fo.get(identField) === f.get(identField)
          })[0]

        this.wellLayer.getSource().removeFeature(origF)

      })
      this.propagateFeatureChange('delete', features)
      !dry && this.save()
    },
    validateLayer (val) {
      if (!this.checkResources()) {
        this.$notify({
          title: `ERROR: ${this.wellLayerName} layer not available`,
          text: `Trying to ${this.wellLayerName} layer`,
          type: 'error'
        })
        return false
      }
      return true
    },
    resetChanges () {
      this.newFeatures = []
      this.modifiedFeatures = []
      this.removedFeatures = []
      this.m = {}
      this.packageFeatures = []
      // this.historyChanges = false
      // this.historyStack = []

      // this.addEnabled = false
      // this.selectEnabled = false
      // this.dragEnabled = false
      // this.editEnabled = false

      // this.wellFeatureSelected = false
    },

    save (clb) {

      this.saving = true
      this.modifiedFeatures = []
      for (let k in this.m) {
        if (this.m.hasOwnProperty(k)) {
          this.modifiedFeatures.push(this.m[k])
        }
      }
      if (!this.newFeatures.length && !this.modifiedFeatures.length && !this.removedFeatures.length) {
        console.log('Nothing to save')
        return
      }

      if (this.markLastModified) {
        this.newFeatures.concat(this.modifiedFeatures).concat(this.removedFeatures).forEach(this.setLastModified)
      } else {
        this.newFeatures.concat(this.modifiedFeatures).concat(this.removedFeatures)
      }


      this.removedFeatures.forEach(f => {
        if (f.get('id')) {
          //make sure last modified tracked
          this.modifiedFeatures.push(f)
        }
      })

      this.historyChanges = false
      this.beforeSaveCallback()

      waterfall([
        (clb) => {
          if (this.lockable && this.newFeatures.length > 0) {
            this.$http.post('/api/layers/check-batch-lock-state/', {
              workpack_id: this.currentProject.workpack.id,
              geo: this.wkt.writeGeometry(this.newFeatures[0].get(this.geometryName))
            }).then(res => {
                if (res.body && res.body.batch_locked) {
                  clb('Batch locked, cannot save')
                } else {
                  clb(null)
                }
              }, res => {
                clb('Failed to validate if batch locked')
            })
          } else {
            clb(null)
          }
        },
        (clb) => {
          this.saveFeatures(this.newFeatures, this.modifiedFeatures, this.removedFeatures,
            this.wellLayer.get('kegs_name'), () => {
              this.saving = false
              this.resetChanges()

              this.$notify({
                title: 'Success',
                text: 'Successfully saved data',
                type: 'success'
              })
              this.saveCallback()
              this.reloadWfsLayer(this.wellLayerName, clb || (() => {}))
              this.historyChanges = this.historyStack.length > 0
              clb(null)
            }, (res) => {
              clb('Could not save changes')
            })
        }
      ], (err, res) => {
        if (err) {
          this.saving = false
          this.$notify({
            title: 'ERROR',
            text: err,
            type: 'error'
          })
          this.historyChanges = this.historyStack.length > 0
          this.resetChanges()
        }

      })

    },
    _mixinProps () {
      let a = {...this.wellAttrs}

      a['well_qty'] = parseInt(a['well_qty'])

      // WORKAROUND FOR LTE SCHEMA FROM ARROW
      let identField = this.identName ? this.identName : 'ident'

      // if identstate not unique revert change to original state
      if (this.initialIdent && !this.identState) {
        this.wellAttrs[identField] = this.initialIdent
      }

      if (this.packageFeatures.length > 0) {
        this.packageFeatures = []
      }
      let packet = new Feature()
      packet.setId(this.wellFeature.get(this.idName))
      packet.set(this.idName, this.wellFeature.get(this.idName))
      packet.set(identField, this.wellFeature.get(identField))

      for (let k in a) {
        if (this.wellAttrs.hasOwnProperty(k)) {
          if (k === identField) {
            this.historyStack.forEach(hf => {
              if (hf['feature'].get(identField) === this.wellFeature.get(identField)) {
                hf['feature'].set(identField, this.wellAttrs[k])
              }
            })
          }
          if (this.wellFeature.get(k) !== this.wellAttrs[k] || k === 'overrides') {
            packet.set(k, this.wellAttrs[k])
            this.wellFeature.set(k, this.wellAttrs[k])
          }

        }
      }

      if (this.markLastModified) {
        this.setLastModified(packet)
        this.setLastModified(this.wellFeature)
      }
      this.packageFeatures.push(packet)

    },
    setLastModified (f) {
      f.set('last_modified_user', this.user.username)
      f.set('last_modified_date', new Date().toISOString())
    },
    validateProps () {
      // TODO: This needs to be cleaned/fixed
      return true
      // let valid = true
      // for (let k in this.wellAttrs) {
      //   if (this.wellAttrs.hasOwnProperty(k) && !this.wellAttrs[k]) {
      //     valid = false
      //     break
      //   }
      // }
      // if (!valid) {
      //   this.$notify({
      //     title: 'ERROR: inavlid input',
      //     text: 'Please, make sure all fields are populated',
      //     type: 'error'
      //   })
      //   return false
      // }
      // return true
    },
    onOK (evt) {
      evt.preventDefault()
      if (!this.validateProps()) {
        this.$notify({
          title: 'Warning',
          text: 'Nor valid properties',
          type: 'warning'
        })
        console.log('not valid props')
        return
      }
      if (this.wellFeature.get('locked')) {
        this.$notify({
          title: 'Warning',
          text: 'This feature is locked',
          type: 'warning'
        })
        return
      }
      if (!this.lockable) {
        this.showForm = false
      }

      if (this.editEnabled) {
        this.historyStack.push({
          'feature': this.wellFeature.clone(),
          'action': 'edit'
        })
      }

      this._mixinProps()

      if (this.addEnabled) {
        this._addFeature(this.wellFeature)
        this.historyStack.push({
          'feature': this.wellFeature.clone(),
          'action': 'add'
        })
      } else {
        if (this.multiEdit && this.selectInteraction.getFeatures().getArray().length > 1) {
          this._edit(this.selectInteraction.getFeatures().getArray())
        } else {
          this._edit(this.packageFeatures)
        }
      }

      if (!this.lockable) {
        this.wellFeature = null
        this.packageFeatures = []
      }
    },
    onCancel () {
      this.initialIdent = null
      this.identState = null
      // console.log('i am testing this')
      // console.log(this.wellFeature)
      // console.log(this.wellFeature['values_'])
      if (this.wellFeature && this.wellFeature['values_'] && this.wellFeature['values_']['major']) {
        console.log('testing passed')
        this.wellFeature['values'] = {
          major: null,
          minor: '',
          photos: null,
          buffer_dist_m: null,
          comments: null,
          cause: []
        }
      }
      if (this.addEnabled) {
        this.wellLayer.getSource().removeFeature(this.drawingFeature)
      }
    },
    checkResources (level) {
      if (!level) {
        level = 1
      }
      let lrs = this.getLayersByName([this.wellLayerName]).filter(l => l['data_type'] === 'wfs' && l['editable'])
      lrs.forEach(layer => {
        if (!layer.checked) {
          layer.checked = true
          this.$mapService.forceCreateLayer(layer)
        }
      })

      if (lrs.length) {
        let l = lrs[0]
        this.wellLayer = this.$mapService.map.getLayers().getArray().filter(layer => {
          return layer.get('kegs_name') === this.wellLayerName && (layer instanceof VectorLayer)
            && layer.get('kegs_id') === l['id']
        })[0]
        this.wellLayerLoaded = !!this.wellLayer
      }

      if (!this.wellLayerLoaded && level < 3) {
        setTimeout( () => {
          this.checkResources(level+1)
        }, 500);
      }

      return !!this.wellLayer
    },
    _addFeature (feature) {
      this.newFeatures.push(feature)
      this.propagateFeatureChange('add', [feature])
      this.save()
    },
    addFeature (e) {
      this.wellFeature = e.feature.clone()
      this.drawingFeature = e.feature
      for (let k in this.wellAttrs) {
        if (this.wellAttrs.hasOwnProperty(k)) {
          this.wellFeature.set(k, this.wellAttrs[k])
        }
      }
      if (!this.noIdentOnInsert) {
        // WORKAROUND FOR LTE SCHEMA FROM ARROW
        if (this.identName) {
          this.wellFeature.set(this.identName, `${this.editorIdent}-${uuidV1()}`)
        } else {
          this.wellFeature.set('ident', `${this.editorIdent}-${uuidV1()}`)
        }
      }

      this.wellFeature.set('workpack_id', this.currentProject.workpack.id)
      this._addFeature(this.wellFeature)
      this.historyStack.push({
        'feature': this.wellFeature.clone(),
        'action': 'add'
      })
    },
    splitFeature (e) {
      let sg = e.feature.clone()
      sg.getGeometry().transform(olProj.get('EPSG:3857'), olProj.get('EPSG:4326'))
      let extent = this.$mapService.map.getView().calculateExtent(this.$mapService.map.getSize())
      let splitter = this.geoJson.writeGeometryObject(sg.getGeometry())
      let gToSplit;
      this.wellLayer.getSource().getFeaturesInExtent(extent).forEach(f => {
        if (!gToSplit) {
          let tg = f.clone()
          tg.getGeometry().transform(olProj.get('EPSG:3857'), olProj.get('EPSG:4326'))
          let g = this.geoJson.writeGeometryObject(tg.getGeometry())
          let i = lineIntersects(g, splitter)
          if (i.features && i.features.length) {
            gToSplit = tg
          }
        }

      })
      if (!gToSplit) {
        this.$notify({
          title: 'ERROR',
          text: 'Nothing to split',
          type: 'info'
        })
        return
      }
      let featureCollection = lineSplit(this.geoJson.writeFeatureObject(gToSplit), this.geoJson.writeFeatureObject(sg))
      // let len = this.wellLayer.getSource().getFeatures().length
      gToSplit.getGeometry().transform(olProj.get('EPSG:4326'), olProj.get('EPSG:3857'))
      this.geoJson.readFeatures(featureCollection).forEach(f => {
        f.getGeometry().transform(olProj.get('EPSG:4326'), olProj.get('EPSG:3857'))
        let gc = f.getGeometry().clone()
        f.setProperties(gToSplit.getProperties())
        f.setGeometry(gc)
        let ident = uuidV1()
        f.set('ident', ident)
        let overrides = JSON.parse(f.get('overrides'))
        if (overrides && overrides.ident) {
          delete overrides.ident
          f.set('overrides', JSON.stringify(overrides))
        }
        f.set('id', null)
        f.set('audit_id', null)
        if (this.markLastModified) {
          this.setLastModified(f)
        }

        this.newFeatures.push(f)
        this.historyStack.push({
          'feature': f.clone(),
          'action': 'add'
        })
      })
      this._delete([gToSplit], true)
      this.save()

    },
    getLayersByName (names) {
      let layers = []
      this.$mapService.walkTree(store.getters['map/layersTree'], node => {
        if (names.indexOf(node['name']) > -1) {
          layers.push(node)
        }
      })

      return layers
    },
    reloadWfsLayer (layerName, callback) {
      let layer = this.getLayersByName([layerName]).filter(node => node['editable'])[0]
      let exists = this.$mapService._layerExists(layer)
      let stopLoading = (err) => {
        callback(err)
      }

      let vectorSource = exists.getSource()
      let featureMap = {}
      let rf = []
      vectorSource.getFeatures().forEach(f => {
        if (f.get(this.idName)) {
          featureMap[f.get(this.idName)] = f
        } else {
          rf.push(f)
        }

      })

      let url = vectorSource.getUrl()()
      this.historyChanges = false
      this.$http.get(url)
        .then(res => {
          let features = vectorSource.getFormat().readFeatures(res.body)
          let nf = []
          features.forEach(f => {
            this.historyStack.forEach(hf => {
              if (hf['action'] === 'add' && hf['feature'].get('ident') === f.get('ident')) {
                hf['feature'].set(this.idName, f.get(this.idName)) //mapping ids
              }
            })
            if (!featureMap[f.get(this.idName)]) {
              nf.push(f)
            } else {
              let existentFeature = featureMap[f.get(this.idName)]
              let props = f.getProperties()
              // console.log(props)
              delete props[this.geometryName]
              existentFeature.setProperties(props, true)
            }
          })
          rf.forEach(f => exists.getSource().removeFeature(f))
          exists.getSource().addFeatures(nf)
          stopLoading(null)
          this.historyChanges = this.historyStack.length > 0
        }, res => {
          console.error(res)
          stopLoading('error')
          this.historyChanges = this.historyStack.length > 0
        })
    },
    undo () {
      if (this.historyStack.length) {
        let step = this.historyStack.pop()
        switch (step['action']) {
          case 'delete':
            this.wellLayer.getSource().addFeature(step['feature'])
            this._addFeature(step['feature'])
            break
          case 'add':
            this._delete([step['feature']])
            break
          case 'edit':
            this.wellLayer.getSource().getFeatures().forEach(f => {
              if (f.get(this.idName) === step['feature'].get(this.idName)) {
                let props = step['feature'].getProperties()
                f.getGeometry().setCoordinates(step['feature'].getGeometry().getCoordinates())
                delete props[this.geometryName]
                f.setProperties(props, true)
                this.propagateFeatureChange('edit', [step['feature']])
              }
            })
            break
        }

      }
      this.historyChanges = this.historyStack.length > 0
    },
    propagateFeatureChange (action, features) {
      if (features instanceof Feature) {
        features = [features]
      }

      if (features instanceof Collection) {
        features = features.getArray()
      }
      features = features.filter(f => f.getGeometry())
      let payload = {
        username: this.user.username,
        layerKegsId: this.wellLayer.get('kegs_id'),
        idName: this.idName,
        action: action,
        features: features.map(f => {
          let fc = f.clone()
          let props = fc.getProperties()

          delete props[this.geometryName]

          return {
            geo: this.wkt.writeGeometry(f.getGeometry()),
            properties: props
          }
        })
      }

      // window.webSocket.send(JSON.stringify(payload))

    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FeatureEditorMixin.js